<div *ngIf="formGroup" [formGroup]="formGroup" class="formItemsBox">
  <div class="form-item" *ngIf="!unVisibleComp.name">
    <mat-form-field appearance="fill">
      <mat-label>Nom</mat-label>
      <input matInput placeholder="" formControlName="name" />
      <mat-error *ngIf="formGroup.controls.name.hasError('required')"> Nom est <strong>obligatoire</strong> </mat-error>
    </mat-form-field>
  </div>

  <div class="form-item" *ngIf="!unVisibleComp.size">
    <mat-form-field appearance="fill">
      <mat-label>Taille</mat-label>
      <input matInput placeholder="" formControlName="size" type="number" />
      <mat-error *ngIf="formGroup.controls.size.hasError('required')"> Taille est <strong>obligatoire</strong> </mat-error>
    </mat-form-field>
  </div>

  <div class="form-item" *ngIf="!unVisibleComp.hidden"><mat-checkbox formControlName="hidden">Caché</mat-checkbox><br /></div>

  <div class="form-item" *ngIf="!unVisibleComp.value">
    <mat-form-field appearance="fill">
      <mat-label>value</mat-label>
      <textarea matInput rows="5" placeholder="" formControlName="value"></textarea>
      <mat-error *ngIf="formGroup.controls.value.hasError('required')"> value est <strong>obligatoire</strong> </mat-error>
    </mat-form-field>
  </div>

  <div class="form-item" *ngIf="!unVisibleComp.format">
    <mat-form-field appearance="fill">
      <mat-label>Format</mat-label>

      <mat-select placeholder="Select" formControlName="format">
        <mat-option value="none">none</mat-option>

        <mat-option value="uppercase">uppercase</mat-option>

        <mat-option value="lowercase">lowercase</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
